var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list__info list-info employee-edit-form"},[_c('v-section-form',{attrs:{"formData":_vm.formData,"editedItem":_vm.editedItem},on:{"submit":_vm.onSectionAdd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }